const initialState = null;

export const archive = (state = initialState, action) => state;
export const landingPage = (state = initialState, action) => state;
